import React from "react";
import { formData } from "../../sections/register/RegisterModal";
import { formatDateEmail, getDayInGerman } from "../../utils/DataFormatter";

const CourseInfo = ({ title }: { title: string }) => {
  return (
    <div className="border-2 border-black px-3">
      <p className="text-sm font-bold -mt-5 bg-white w-fit px-2">
        Zusammenfassung
      </p>
      <table className="table-auto w-full">
        <thead className="text-sm font-bold border-b border-black mx-20">
          <tr>
            <th className="px-4 py-2 text-left">Bezeichnung</th>
            <th className="px-4 py-2 text-center">Preis</th>
            <th className="px-4 py-2 text-center">Anzahl</th>
            <th className="px-4 py-2 text-right">Total</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          <tr className="border-b border-black">
            <td className="px-4 py-2">{title}</td>
            <td className="px-4 py-2 text-center whitespace-nowrap">
              CHF 150.00 if Northehleimer 130$
            </td>
            <td className="px-4 py-2 text-center">1</td>
            <td className="px-4 py-2 text-right  whitespace-nowrap">
              CHF 150.00
            </td>
          </tr>
          <tr>
            <td className=" px-4 py-2 text-right" colSpan={3}>
              Nicht MwSt-pflichtig
            </td>
            <td className="px-4 py-2 text-right">CHF 0.00</td>
          </tr>
          <tr>
            <td className="px-4 pb-2 text-right font-bold" colSpan={3}>
              Total (CHF)
            </td>
            <td className="px-4 pb-4 text-right  whitespace-nowrap">
              CHF 150.00
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const DriverDetails = ({
  firstName,
  lastName,
  email,
}: {
  firstName: string;
  lastName: string;
  email: string;
}) => {
  return (
    <div className="border-2 border-black px-3">
      <p className="text-sm font-bold -mt-5 bg-white w-fit px-2">Teilnehmer</p>
      <table className="table-auto w-full">
        <thead className="text-sm font-bold mx-20">
          <tr>
            <th className="px-4 py-2 text-left">Nr.</th>
            <th className="px-4 py-2 text-center">Name</th>
            <th className="px-4 py-2 text-center">Vorname</th>
            <th className="px-4 py-2 text-left">Email</th>
          </tr>
        </thead>
        <tbody className="text-sm pb-20">
          <tr className="border-b ">
            <td className="px-4 py-2 w-fit">1</td>
            <td className="px-4 py-2 text-center">{firstName}</td>
            <td className="px-4 py-2 text-center">{lastName}</td>
            <td className="px-4 py-2 text-left">{email}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const CourseDateRow = ({
  date,
  startTime,
  endTime,
}: {
  date: string;
  startTime: string;
  endTime: string;
}) => {
  return (
    <>
      <td className="px-4 py-2 w-fit" colSpan={1}>
        {getDayInGerman(date)}
      </td>
      <td className="px-4 py-2 text-left" colSpan={5}>
        {date} {startTime} - {endTime}
      </td>
    </>
  );
};

const CourseDateTime = ({
  type,
  title,
  data,
}: {
  type: "vku" | "plus" | null;
  title: string;
  data: any;
}) => {
  return (
    <div className="border-2 border-black px-3">
      <p className="text-sm font-bold -mt-5 bg-white w-fit px-2">
        Kurs: {title}
      </p>
      <table className="table-auto w-full">
        <thead className="text-sm font-bold mx-20">
          <tr>
            <th className="px-4 py-2 text-left" colSpan={1}>
              Dauer
            </th>
            <th className="px-4 py-2 text-left" colSpan={5}>
              Datum
            </th>
            <th className="px-4 py-2 text-left" colSpan={1}>
              Wochentag
            </th>
          </tr>
        </thead>
        <tbody className="text-sm pb-20">
          <tr>
            {type === "vku" ? (
              <td className="px-4 py-2 w-fit" colSpan={1}>
                2 Tag(e) Total 2 Lektionen
              </td>
            ) : (
              <td className="px-4 py-2 w-fit" colSpan={1}>
                3 Tag(e) Total 3 Lektionen
              </td>
            )}
            <td className="px-4 py-2 text-left" colSpan={5}>
              {data?.fDate} - {type === "vku" ? data?.sDate : data?.tDate}
            </td>
            <td className="px-4 py-2 text-left" colSpan={1}>
              {getDayInGerman(data?.fDate)}, {getDayInGerman(data?.sDate)}
              {data?.tDate != null && " ,"}
              {getDayInGerman(data?.tDate)}
            </td>
          </tr>
        </tbody>
      </table>
      <table className="table-auto w-full">
        <thead className="text-sm font-bold mx-20">
          <tr>
            <th className="px-4 py-2 text-left" colSpan={1}>
              Tag
            </th>
            <th className="px-4 py-2 text-left w-[40%]" colSpan={5}>
              Datum, Zeit
            </th>
            <th className="px-4 py-2 text-left" colSpan={2}>
              Raum
            </th>
            <th className="px-4 py-2 text-left" colSpan={3}>
              Ort
            </th>
          </tr>
        </thead>
        <tbody className="text-sm pb-20">
          <tr>
            <CourseDateRow
              date={data?.fDate}
              startTime={data?.fStartTime}
              endTime={data?.fEndTime}
            />
            <td className="px-4 py-2 text-left" colSpan={2}>
              Fahrschule Lumi
            </td>
            <td className="px-4 py-2 text-left" colSpan={3}>
              Winterthur City Römerstrasse 76 8404 Winterthur
            </td>
          </tr>
          <tr>
            <CourseDateRow
              date={data?.sDate}
              startTime={data?.sStartTime}
              endTime={data?.sEndTime}
            />
          </tr>
          {data?.tDate && (
            <tr>
              <CourseDateRow
                date={data?.tDate}
                startTime={data?.tStartTime}
                endTime={data?.tEndTime}
              />
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const Footer = () => {
  return (
    <div>
      <p className="text-sm">
        <strong>Kursgeld:</strong> Bitte das Kursgeld CHF 150.- am 1.Kurstag bar
        mitbringen.
      </p>
      <p className="text-sm">
        <strong>Pünktliches Erscheinen:</strong> Zu spätes Eintreffen am Kursort
        hat in jedem Fall die Verrechnung des ganzen Kursgeldes zur Folge.
      </p>
      <p className="text-sm mt-4 font-bold">Abmeldung:</p>
      <p className="text-sm">
        Abmeldungen sind nur schriftlich per SMS unter:{" "}
        <a href="tel:+41764727563" className="text-blue-600">
          +41 76 472 75 63
        </a>{" "}
        oder email:{" "}
        <a href="mailto:kontakt@fahrschul-kurse.ch" className="text-blue-600">
          kontakt@fahrschul-kurse.ch
        </a>
        <br />
        Bei Abmeldungen, welche weniger als 4 Tage vor Kursbeginn erfolgen oder
        unentschuldigtem Nichterscheinen, wird der ganze Kursbeitrag in Rechnung
        gestellt.
      </p>
    </div>
  );
};

const BookingConfirmation = ({
  data,
  cardSelectedValues,
  type,
}: {
  data: formData;
  cardSelectedValues: any;
  type: "vku" | "plus" | null;
}) => {
  const title = `${
    type === "vku" ? "Verkehrskunde-Kurs" : "Nothelferkurse"
  } Winterthur City, ${formatDateEmail(cardSelectedValues?.fDate)}`;

  return (
    <div id="emailContent">
      <div className="">
        <p className="text-xl text-start font-bold">
          Buchungsbestätigung {title}
        </p>
        <div className="mt-10 grid grid-cols-2">
          <div>
            <p className="text-sm">
              {data?.firstName} {data?.lastName}
              <br />
              {data?.streetAddress}
              <br />
              {data?.postalCode} {data?.city}
              <br />
              {data?.telNumber}
              <br />
              {data?.email}
              <br />
              {data?.bday}
              <br />
              {data?.learnerSwissNumber}
            </p>
          </div>
          <div className="my-auto">
            <p className="text-sm">
              Fahrschul-Kurse
              <br />
              www.fahrschul-kurse.ch
            </p>
          </div>
        </div>
        <div className="mt-20">
          <CourseInfo title={title} />
        </div>
        <div className="mt-5">
          <DriverDetails
            firstName={data?.firstName}
            lastName={data?.lastName}
            email={data?.email}
          />
        </div>
        <div className="mt-5">
          <CourseDateTime type={type} title={title} data={cardSelectedValues} />
        </div>
        <div className="mt-10 mb-2">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmation;
